export const enum MLModelType {
  Antman = 'Antman',
  HumanVision = 'HumanVision',
  LID = 'LID',
}

export const enum MLFeatureType {
  MatchBlur = 'MatchBlur',
  MatchAutoReportImage = 'MatchAutoReportImage',
  AfterMatchHVReportPopupMinor = 'AfterMatchHVReportPopupMinor',
  MatchHVUnderageExistAutoReport = 'MatchHVUnderageExistAutoReport',
  MatchLID = 'MatchLID',
}

export enum DETECTION_SOURCE {
  ON_DEVICE = 'on_device',
  SERVER = 'server',
}

export interface MLModelConfig {
  modelId: string;
  type: MLModelType;
  intervalMs: number;
  maxLatencyLimit: number;
  maxRun?: number;
}

export interface MLFeatureCondition {
  modelType: MLModelType;
  modelIndex: number;
  criteriaWindow: number;
  criteriaThreshold: number;
  threshold: number;
  maxInferencesLimit: number;
}

export interface MLFeatureConfig {
  featureType: MLFeatureType;
  featureCondition: MLFeatureCondition[];
}

export interface BaseMLConfig {
  modelId: string;
  modelConfig: MLModelConfig;
}

export type MLConfigSource = 'api' | 'fallback';

export interface MLResolvedModelConfig extends BaseMLConfig {
  modelType: MLModelType;
  featureConfigs: MLFeatureConfig[];
  source: MLConfigSource;
}

export type MLConfigStore = Partial<Record<MLModelType, MLResolvedModelConfig>>;

// ML inference logging
export interface MLInference {
  modelStateInitialized: boolean;
  inferenceAt: number;
  latencyMs: number;
  inference: string[];
  featureIds?: string[];
}

// 피쳐 threshold를 넘긴 시점에 대한 기록
export interface MLThresholdInference {
  model: string;
  taskIndex: number;
  index: number;
}

// 피쳐가 trigger된 시점에 대한 기록
export interface MLFeatureTriggerInference {
  model: string;
  taskIndex: number;
  index: number;
  criteriaWindow: number;
  triggeredCount: number;
}

export interface AntmanFeatureCaptureData {
  file: Blob;
  triggeredAt: number;
  inferenceIndex: number;
  handled?: boolean;
}

export interface HvmFeatureCaptureData {
  file: Blob;
  triggeredAt: number;
  score: number; // result[modelIndex] — 최고 점수 비교용
  result: number[]; // trigger 시점의 전체 추론 결과 (서버 리포트용)
  inferenceIndex: number;
}

/**
 * Feature별 독립 슬라이딩 윈도우.
 * criteriaWindow 크기의 boolean ring buffer로, threshold 초과 여부만 기록한다.
 */
export interface FeatureRingBuffer {
  buffer: boolean[];
  writeIndex: number;
  trueCount: number;
  filledCount: number;
}

export interface FeatureTriggerState {
  featureType: MLFeatureType;
  condition: MLFeatureCondition;
  ring: FeatureRingBuffer;
  triggeredAt: number | null;
}
